import { useMutation, useQueryClient } from '@tanstack/react-query';
import { calendarConnectionsService } from '../api/calendar-connections.service';
import { CALENDAR_CONNECTIONS_KEYS } from './queryKeys';

/**
 * Disconnects a calendar connection — revokes the provider token and deletes
 * the connection, its linked calendars and their synced events.
 * Destructive: callers must confirm via useConfirm + ConfirmDialog first.
 */
export function useDeleteCalendarConnection() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (connectionId: string) => calendarConnectionsService.deleteConnection(connectionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CALENDAR_CONNECTIONS_KEYS.all });
    },
  });
}
